import { render, staticRenderFns } from "./ModalHotAlert.vue?vue&type=template&id=19bc4db4&"
import script from "./ModalHotAlert.vue?vue&type=script&lang=js&"
export * from "./ModalHotAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports